import React from "react";
import { List, ListItem } from "@material-ui/core";
import { AbsComponentFactory, NodeProps, MetaNode } from "../..";
import { ElementNode, NodeTag, PageNode } from "dynamo-models";
import { ToolboxNode, ToolboxContainerNode } from "../../supportNodes";
import { PageWidget, ElementWidget } from "../primary";
import { connect } from "react-redux";
import { IEditorState } from "../../redux";

export interface IToolboxProps {
    factory: AbsComponentFactory;
    nodes: MetaNode;
    allowNewPages: boolean;
    maxHeight?: number;
    toolboxContainer?: ToolboxContainerNode;
}

class EditorToolbox extends React.Component<IToolboxProps> {
    render() {
        const {
            factory,
            toolboxContainer,
            maxHeight,
        } = {...this.props}

        if (toolboxContainer === undefined) {
            return null;
        }

        const getNodes = () => (toolboxContainer !== undefined ? toolboxContainer.getChildren() : []) as ToolboxNode[];

        return (
            <List style={{ maxHeight: maxHeight !== undefined ? `${maxHeight}em` : undefined, padding: 0 }}>
            {
                getNodes().filter(v => v.child !== undefined).map(v => {
                    let keyIndex = 0;
                    let InnerRender = () => <div />;
                    let props: NodeProps<PageNode> | NodeProps<ElementNode> = new NodeProps(v.child as PageNode | ElementNode, toolboxContainer, factory, factory);
                    if (v.child !== undefined && v.child.tag === NodeTag.Page) {
                        props = new NodeProps(v.child as PageNode, toolboxContainer, factory, factory);
                        InnerRender = () => <PageWidget {...props} />
                    }
                    else if (v.child !== undefined && v.child.tag === NodeTag.Element) {
                        props = new NodeProps(v.child as ElementNode, toolboxContainer, factory, factory, undefined, v.label);
                        InnerRender = () => <ElementWidget {...props as NodeProps<ElementNode>} />
                    }

                    return (
                        <ListItem key={v.nodeId} style={{ marginLeft: 0 }}>
                            <InnerRender />
                        </ListItem>
                    )
                })
            }
            </List>
        )
    }
}

const stateToProps = (state: IEditorState) => ({
    toolboxContainer: state.container.toolboxContainer,
});

export const EditorToolboxWidget = connect(stateToProps)(EditorToolbox);